import {
  buildServices
} from './utils/build_services'
import buildParamList from './utils/build_params'
import omitBy from 'lodash.omitby'
import isEmpty from 'lodash.isempty'
import {
  adaptIFramesToStore,
  adaptIFrameToApi,
  adaptIFrameToStore
} from './adapters/iframeAdapter'
import { IFRAME } from '@/services/axios.config'

const services = [
  {
    name: 'listIFrames',
    method: 'get',
    url: (params) => `/iframes${buildParamList(omitBy(params, isEmpty))}`,
    resolver: adaptIFramesToStore
  },
  {
    name: 'getIFrame',
    method: 'get',
    url: (params) => `/iframes/${params.iframeId}`,
    resolver: adaptIFrameToStore
  },
  {
    name: 'createIFrame',
    method: 'post',
    url: () => `/iframes`,
    data: (params) => {
      return adaptIFrameToApi(params)
    },
    resolver: adaptIFrameToStore
  },
  {
    name: 'editIFrame',
    method: 'patch',
    url: (params) => `/iframes/${params.iframeId}`,
    data: (params) => {
      return adaptIFrameToApi(params)
    },
    resolver: adaptIFrameToStore
  }
]

export const {
  listIFrames,
  getIFrame,
  createIFrame,
  editIFrame
} = buildServices(IFRAME, services)